import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';
import MemberCardRedesign from '@molecules/MemberCardRedesign/MemberCardRedesign';
import { H3 } from '@react/styledComponents';
import React from 'react';
import styled from 'styled-components';

const ContainerStyled = styled.div`
    background-blend-mode: multiply;
    background-clip: border-box, border-box;
    background-color: ${colors.brightSunTint};
    background-image: url('/assets/images/pattern-circles.png'), none;
    background-origin: padding-box, padding-box;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 24px;

    @media ${mediaQueries.md} {
        gap: 40px;
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    @media ${mediaQueries.xl} {
        gap: 90px;
    }
`;

const HeadlineStyled = styled(H3)`
    line-height: 45px !important;
`;

const TrusteeLiaisonPanel = () => {
    return (
        <ContainerStyled>
            <div className="flex items-center">
                <HeadlineStyled>Have questions? Send us a message and we'll be happy to assist you.</HeadlineStyled>
            </div>

            <div className="mt-1.5rem md:mt-0">
                <MemberCardRedesign
                    companyName="ICSC"
                    designations=""
                    displayLocation="New York, NY"
                    firstName="Dana"
                    fullName="Dana Sherman"
                    graphID="MDE6TWVtYmVyNzI0MDk0"
                    id={724094}
                    isFavorite={false}
                    lastName="Sherman"
                    photoURL="https://uploads.icsc.com/cropped/1730764.jpg"
                    title="SVP, Strategy & Chief of Staff"
                />
            </div>
        </ContainerStyled>
    );
};

export default TrusteeLiaisonPanel;
